"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinSchema = void 0;
const zod_1 = require("zod");
const zod_field_presence_1 = require("../../Utils/zod-field-presence");
const SchDrawingWithLayers_1 = require("./SchDrawingWithLayers");
const DrawingBase_1 = require("./DrawingBase");
const XYPosition_1 = require("./XYPosition");
exports.PinSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('pin'),
    ref: zod_1.z.string(),
    name: zod_1.z.string(),
    number: (0, zod_field_presence_1.coercedString)(),
    start: XYPosition_1.XYPositionSchema,
    end: XYPosition_1.XYPositionSchema,
    layer: zod_1.z.number(),
    isNetLabel: zod_1.z.coerce.boolean().optional(),
    hidden: zod_1.z.coerce.boolean().optional(),
    drawings: zod_1.z.lazy(() => SchDrawingWithLayers_1.SchDrawingWithLayersSchema.array().optional()),
});
//# sourceMappingURL=Pin.js.map